export default[
    {
        path: 'myDemand',
        name: 'myDemand',
        component: () => import(/* webpackChunkName: "demand" */ '@/views/company/demand/index.vue'),
    },
];
